import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { afterSignInPath } from '../../utils/safeNext';

interface PublicRouteProps {
  children: React.ReactNode;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { state } = useAuth();
  const location = useLocation();

  // If authenticated, redirect to the intended destination, query included
  // (a link into a group, ?group=…, must arrive whole), or the link's next.
  if (state.isAuthenticated) {
    return <Navigate to={afterSignInPath(location)} replace />;
  }

  // If not authenticated, render the public content
  return <>{children}</>;
};